/* tslint:disable */
/* eslint-disable */
/**
 * Ameta Delivery API
 * This API manages the projects and docuements that are stored in the Ameta Document Delivery. The API used oAuth2 flow for authorization.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GeoJSONLocation,
    GeoJSONLocationFromJSON,
    GeoJSONLocationFromJSONTyped,
    GeoJSONLocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateProject
 */
export interface UpdateProject {
    /**
     * 
     * @type {string}
     * @memberof UpdateProject
     */
    projectName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProject
     */
    projectNumber?: string;
    /**
     * 
     * @type {GeoJSONLocation}
     * @memberof UpdateProject
     */
    projectLocation?: GeoJSONLocation;
    /**
     * 
     * @type {string}
     * @memberof UpdateProject
     */
    projectDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProject
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProject
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProject
     */
    customerProjectNumber?: string;
}

export function UpdateProjectFromJSON(json: any): UpdateProject {
    return UpdateProjectFromJSONTyped(json, false);
}

export function UpdateProjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectName': !exists(json, 'projectName') ? undefined : json['projectName'],
        'projectNumber': !exists(json, 'projectNumber') ? undefined : json['projectNumber'],
        'projectLocation': !exists(json, 'projectLocation') ? undefined : GeoJSONLocationFromJSON(json['projectLocation']),
        'projectDescription': !exists(json, 'projectDescription') ? undefined : json['projectDescription'],
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'customerProjectNumber': !exists(json, 'customerProjectNumber') ? undefined : json['customerProjectNumber'],
    };
}

export function UpdateProjectToJSON(value?: UpdateProject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectName': value.projectName,
        'projectNumber': value.projectNumber,
        'projectLocation': GeoJSONLocationToJSON(value.projectLocation),
        'projectDescription': value.projectDescription,
        'startDate': value.startDate,
        'endDate': value.endDate,
        'customerProjectNumber': value.customerProjectNumber,
    };
}


